import { memo } from 'react';
import { Grid } from 'components/ui';
import { IndexListItemHeader } from 'components/styles_components/list';
import SortableHeader from 'components/sortable_header';
import useMobile from 'hooks/use_mobile';

const ListHeader = ({ visible, sortBy, onSortChange }) => {
  const isMobile = useMobile();

  if (!visible || isMobile) {
    return null;
  }

  return (
    <IndexListItemHeader>
      <Grid container justifyContent="center" alignItems="center">
        <Grid size={{ xs: 4 }} textAlign="left">
          <SortableHeader
            field="name"
            label="name"
            sortBy={sortBy}
            onSortChange={onSortChange}
            textAlign="left"
          />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <SortableHeader
            field="status"
            label="inspection.status"
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <SortableHeader
            field="due_date"
            label="inspection.due_date"
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <SortableHeader
            field="done_at"
            label="inspection.done_at"
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </Grid>
        <Grid size={{ xs: 2 }} textAlign="center">
          <SortableHeader
            field="result"
            label="inspection.result"
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </Grid>
      </Grid>
    </IndexListItemHeader>
  );
};

export default memo(ListHeader);
